<div class="row">
    <div class="leftcolumn">
        <div class="card">
            <app-carousel></app-carousel>
        </div>
        <div class="card">
            <h2>Our Signature Dishes</h2>
            <app-signature></app-signature>
        </div>
    </div>
    <div class="rightcolumn">
        <div class="cardwithborder">
            <div>
                <app-drawer></app-drawer>
              
            </div>
           
        </div>
        <div class="cardwithborder">
            <h3>Our Customers</h3>
            <div >
                <img mat-card-image src="assets/images/customer1.jpeg"  class="ripple-image">
            </div>
            <div >
                <img mat-card-image src="assets/images/customer2.jpeg"  class="ripple-image">
            </div>
            <div >
                <img mat-card-image src="assets/images/customer3.jpeg"  class="ripple-image">
            </div>
        </div>
       
    </div>
</div>